/**
 * LD key `om_tech_21630_vendor_plugin_management` (the React SDK camelCases keys). Default off
 * to match integration-service, which 404s these routes while its copy is off.
 */
export const VENDOR_PLUGIN_MANAGEMENT_FLAG = 'omTech21630VendorPluginManagement';
export const VENDOR_PLUGIN_MANAGEMENT_FLAG_DEFAULT = false;
